import { _ as _extends } from './extends-3e8335ef.esm.js';
import { useFormikContext } from 'formik';
import React__default, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { A as AppTextInput } from './index-ce884795.esm.js';
import { u as useTheme } from './useTheme-e658d3b6.esm.js';
import { A as AppText } from './index-495429ce.esm.js';

const ERROR_OFFSET = 3;
var Constants = {
  ERROR_OFFSET
};

function AppErrorMessage(_ref) {
  let {
    message,
    top = -6,
    left = 20,
    isStatic = false
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  return /*#__PURE__*/React__default.createElement(AppText, {
    style: {
      color: currentTheme?.theme?.red,
      marginLeft: left,
      ...(isStatic ? {
        marginTop: 4
      } : {
        top,
        position: "absolute"
      })
    }
  }, message);
}
StyleSheet.create({});
AppErrorMessage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppErrorMessage",
  "props": {
    "top": {
      "defaultValue": {
        "value": "-6",
        "computed": false
      },
      "required": false
    },
    "left": {
      "defaultValue": {
        "value": "20",
        "computed": false
      },
      "required": false
    },
    "isStatic": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};

function AppFormField(_ref) {
  let {
    showTextChips,
    name,
    width,
    onChange = () => {},
    formFieldContainerStyle,
    errorOffset,
    ...otherProps
  } = _ref;
  const {
    setFieldTouched,
    setFieldValue,
    errors,
    touched,
    initialValues,
    values
  } = useFormikContext();
  const [inputTags, setInputTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const onChangeValue = value => {
    if (typeof showTextChips === "undefined") setFieldValue(name, value);else setInputValue(value);
    onChange(value);
  };
  // if errors[name] is a json object, stringify it

  const stringifiedError = errors[name] && typeof errors[name] === "object" ? JSON.stringify(errors[name]) : errors[name];
  const onTextChipSubmit = event => {
    if (event?.nativeEvent?.text !== "") {
      inputTags.push(event.nativeEvent.text);
      setInputTags(inputTags);
      setFieldValue(name, inputTags);
      setInputValue("");
    }
  };
  const handleDeleteTagClick = item => {
    if (item) {
      var filtered = inputTags.filter(function (value) {
        return value !== item;
      });
      setInputTags(filtered);
      setFieldValue(name, filtered);
    }
  };
  return /*#__PURE__*/React__default.createElement(View, {
    style: [{
      paddingBottom: Constants.ERROR_OFFSET * 3
    }, formFieldContainerStyle]
  }, /*#__PURE__*/React__default.createElement(AppTextInput, _extends({}, otherProps, {
    inputTags: inputTags,
    onDeleteTagClick: handleDeleteTagClick,
    width: width,
    defaultValue: initialValues && initialValues[name],
    onBlur: () => setFieldTouched(name),
    onChangeText: text => onChangeValue(text),
    value: typeof showTextChips === "undefined" ? values[name] : inputValue,
    onEndEditing: item => {
      showTextChips && onTextChipSubmit(item);
    }
  })), touched[name] && errors[name] && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    message: stringifiedError,
    top: errorOffset
  }));
}
AppFormField.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormField",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppFormField as A, Constants as C, AppErrorMessage as a };
